import { InputAdornment } from "@vapor/react-material";

const proRataOptions = t => [
    {
        id: "NON_DEDUCTIBLE_VAT_ON_COSTS",
        value: t("business.fields.proRataManagementType.NON_DEDUCTIBLE_VAT_ON_COSTS")
    },
    {
        id: "NON_DEDUCTIBLE_VAT_DINSTINCT_FROM_COSTS",
        value: t("business.fields.proRataManagementType.NON_DEDUCTIBLE_VAT_DINSTINCT_FROM_COSTS")
    }
];

export const proRataRows = (t, itemToSave, isEditing) => {
    return [
        [
            {
                component: "radio",
                radioGroupAlign: "vertical",
                label: t("business.fields.proRataManagementType.label"),
                name: "proRataManagementType",
                withMargin: true,
                fullWidth: true,
                style: { minWidth: "30rem" },
                options: proRataOptions(t)
            }
        ],
        [
            {
                component: "textfield",
                labelWithTooltip: {
                    label: t("business.fields.proRataNonDeducibilityRate.label"),
                    tooltip: {
                        message: itemToSave?.proRataManagementType
                            ? itemToSave?.proRataManagementType === "NON_DEDUCTIBLE_VAT_ON_COSTS"
                                ? t("business.fields.proRataNonDeducibilityRate.tips.NON_DEDUCTIBLE_VAT_ON_COSTS")
                                : t(
                                      "business.fields.proRataNonDeducibilityRate.tips.NON_DEDUCTIBLE_VAT_DINSTINCT_FROM_COSTS"
                                  )
                            : null,
                        placement: "bottom"
                    },
                    showTooltip: isEditing
                },
                name: "proRataNonDeducibilityRate",
                fullWidth: true,
                withMargin: true,
                style: { minWidth: "42rem" },
                disabled: itemToSave?.proRataManagementType === "NON_DEDUCTIBLE_VAT_ON_COSTS",
                additionalProps: {
                    sx: { width: "12rem" },
                    InputProps: {
                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        style: { textAlign: "left", width: "7.5rem" },
                        inputProps: {
                            style: { textAlign: "left", width: "4.5rem" },
                            onChange: e => {
                                const value = e.target.value;
                                if (value && !/^\d+$/.test(value)) {
                                    e.target.value = value.slice(0, -1);
                                }
                                e.target.value = e.target.value.replace(/\D/g, "");
                                if (e.target.value > 100) {
                                    e.target.value = 100;
                                }
                                if (e.target.value < 0) {
                                    e.target.value = 0;
                                }
                            }
                        }
                    }
                }
            }
        ]
    ];
};
